import { ColoursObj, Icon } from '@eventr/common-storybook'
import { useEffect, useRef } from 'react'
import {
    ReactZoomPanPinchContentRef,
    TransformComponent,
    TransformWrapper,
} from 'react-zoom-pan-pinch'
import { create } from 'zustand'
import { windowSizes } from '../windowState/windowSignals'

export interface IImageFrameStoreState {
    open: boolean
    source: string | null
}

export interface IImageFrameStoreActions {
    openImageFrame: (source: string) => void
    closeImageFrame: () => void
}

export interface IImageFrameStore
    extends IImageFrameStoreState,
    IImageFrameStoreActions { }

const defaultImageFrameStore: IImageFrameStoreState = {
    open: false,
    source: null,
}

/**
 * Drawer Store
 * One drawer per instance
 */
export const useImageFrameStore = create<IImageFrameStore>((set) => ({
    ...defaultImageFrameStore,
    openImageFrame: (source: string) => {
        set({ open: true, source: source })
    },
    closeImageFrame: () => {
        set({ open: false, source: null })
    },
}))

export type TImageFrameType = {
    open: boolean
    imageSource?: string
}

export const ImageFrame: React.FC<TImageFrameType> = ({
    open,
    imageSource,
}) => {
    const pinchRef = useRef<ReactZoomPanPinchContentRef | null>(null)
    useEffect(() => {
        if (pinchRef.current) {
            pinchRef.current.resetTransform()
        }
    }, [open])
    return (
        <div
            style={{
                height: '100vh',
                width: '100vw',
                paddingTop: windowSizes.value.insets?.insets.top ?? 0 + 'px',
                boxSizing: 'border-box',
                backgroundColor: ColoursObj.shades.shade0,
                overflow: 'visible',
                position: 'relative',
                display: open ? 'flex' : 'none',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <TransformWrapper ref={pinchRef}>
                <TransformComponent
                    wrapperStyle={{ overflow: 'visible' }}
                    contentStyle={{ height: '100%', width: '100%' }}
                >
                    <img
                        alt="header"
                        style={{
                            objectFit: 'contain',
                            height: `calc(100vh -  ${windowSizes.value.insets?.insets.top ?? 0}px`,
                            width: '100vw',
                            // maxHeight: `calc(100vh -  ${windowSizes.value.insets.insets.top}px`,
                            // maxWidth: '100vw',
                        }}
                        loading="lazy"
                        src={imageSource}
                    ></img>
                </TransformComponent>
            </TransformWrapper>
            <div
                style={{
                    position: 'absolute',
                    top: windowSizes.value.insets?.insets.top ?? 0 + 'px',
                    left: '0px',
                    padding: '8px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                onClick={() => {
                    // close
                    useImageFrameStore.getState().closeImageFrame()
                }}
            >
                <div
                    style={{
                        padding: '4px',
                        borderRadius: '24px',
                        backgroundColor: ColoursObj.shades.shade0 + '20',
                    }}
                >
                    <Icon name="Exit" iconColour={ColoursObj.shades.shade5} />
                </div>
            </div>
        </div>
    )
}
